import './styles.scss';

import React from 'react';

const VideoBuffering = () => {
    return (
        <div className="video-buffering-wrapper">
            <div className='loader-animation'>
                <div className='loader-circle'></div>
                <div className='loader-circle'></div>
                <div className='loader-circle'></div>
                <div className='loader-circle'></div>
            </div>
        </div>
    );
}

export default VideoBuffering;